export const OVERLAY_PATH = 'https://web-native-display-campaign.clevertap.com/production/lib-overlay/overlay.js'
export const CSS_PATH = 'https://web-native-display-campaign.clevertap.com/production/lib-overlay/style.css'
